import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css, keyframes } from 'styled-components'

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  outline: 0;

  height: ${props => (props.small ? '2.25rem' : '3rem')};
  font-size: ${props => (props.small ? '0.75rem' : '1rem')};
  padding: 0
    ${props => (props.small ? '1.25rem' : props.icon ? '1rem' : '2rem')};
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.08em;
  border-radius: var(--border-radius-button);
  cursor: pointer;

  transition-property: background-color, border-color, color, opacity;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);

  ${props => {
      const { variant } = props

      let fgColor
      let bgColor
      let borderColor
      let bgColorHover
      let borderColorHover

      switch (variant) {
        case 'primary':
          bgColor = 'var(--color-primary)'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = 'var(--color-primary-hover)'
          fgColor = '#ffffff'
          break
        case 'secondary':
          bgColor = 'var(--color-secondary)'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = 'var(--color-secondary-hover)'
          fgColor = '#ffffff'
          break
        case 'secondary-outline':
          bgColor = 'var(--color-background-secondary)'
          bgColorHover = bgColor
          fgColor = 'var(--color-secondary)'
          borderColor = fgColor
          borderColorHover = borderColor
          break
        case 'facebook':
          bgColor = '#3b5998'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = bgColor
          fgColor = '#ffffff'
          break
        case 'google':
          bgColor = '#ea4335'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = bgColor
          fgColor = '#ffffff'
          break
        case 'apple':
          bgColor = '#000'
          borderColor = bgColor
          borderColorHover = borderColor
          bgColorHover = bgColor
          fgColor = '#ffffff'
          break
        default:
          bgColor = 'var(--color-background-primary)'
          bgColorHover = bgColor
          fgColor = 'var(--color-primary)'
          borderColor = fgColor
          borderColorHover = borderColor
          break
      }

      return css`
        background-color: ${bgColor};
        color: ${fgColor};
        border: 1px solid ${borderColor};

        &:hover {
          background-color: ${bgColorHover};
          border-color: ${borderColorHover};
        }

        &:disabled {
          background-color: ${bgColor};
          border-color: ${borderColor};
        }
      `
    }}
    :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const IconWrapper = styled.span`
  display: flex;
  margin-right: 1rem;
  font-size: 1.25em;
  align-items: center;
  justify-content: center;
`

const LabelWrapper = styled.span`
  flex: auto;
  text-align: center;
  white-space: nowrap;
  position: relative;
`

const Rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const Loader = styled.div`
  width: 1rem;
  height: 1rem;
  border: 2px solid #ffffff;
  border-left: 2px solid var(--color-primary);
  border-radius: 1rem;

  margin-right: 0.5rem;

  animation: ${Rotate};
  animation-duration: 500ms;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`

function ActionButton(props) {
  const {
    children,
    type,
    variant,
    disabled,
    icon,
    small,
    loading,
    ...theProps
  } = props

  return (
    <StyledButton
      {...theProps}
      type={type}
      variant={variant}
      disabled={disabled || loading}
      icon={icon}
      small={small}
    >
      {icon && <IconWrapper>{icon}</IconWrapper>}
      {loading && <Loader />}
      <LabelWrapper>{children}</LabelWrapper>
    </StyledButton>
  )
}

ActionButton.defaultProps = {
  children: null,
  icon: null,
  type: 'button',
}

ActionButton.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.node,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  small: PropTypes.bool,
}

export default ActionButton
